import idlImport from './reversi.did.js';
export const idlFactory = idlImport;
export const canisterId = "qxd6u-vqaaa-aaaah-qbpcq-cai";
